// Generated from ESF schema: provision
// Do not edit manually!
/** Supported cloud providers */
export var CloudProvider;
(function (CloudProvider) {
    CloudProvider["Gcp"] = "gcp";
    CloudProvider["Aws"] = "aws";
    CloudProvider["Azure"] = "azure";
    CloudProvider["Cloudflare"] = "cloudflare";
})(CloudProvider || (CloudProvider = {}));
/** Types of nodes in the eStream network */
export var NodeType;
(function (NodeType) {
    NodeType["Edge"] = "edge";
    NodeType["Scatter"] = "scatter";
    NodeType["Core"] = "core";
    NodeType["Compute"] = "compute";
    NodeType["Ops"] = "ops";
    NodeType["Bridge"] = "bridge";
})(NodeType || (NodeType = {}));
//# sourceMappingURL=provision.js.map